// extracted by mini-css-extract-plugin
module.exports = {"range":"Range_range__ZOO7E"};